import { ResponsiveImage } from 'approot/shared/images/imgix-responsive.constants';

export function getLargestImage(imageUrls: ResponsiveImage[] | null) {
  return imageUrls?.at(-1)?.urls.at(-1)?.url || '';
}
